import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentMethodREAIcon = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.52 86.52">
        <title>REA-Paiement-3-4X</title>
        <g id="Calque_1" data-name="Calque 1">
          <g id="Calque_5" data-name="Calque 5">
            <g id="Calque_2" data-name="Calque 2">
              <path
                fill="#5c9832"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="2px"
                d="M60.7,14.2,20.2,28.9a8.1,8.1,0,0,0-4.8,10.2l7.9,21.8a8.1,8.1,0,0,0,10.2,4.8L74,51a8.1,8.1,0,0,0,4.8-10.2L70.9,19A7.94,7.94,0,0,0,60.7,14.2Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="#fff"
                d="M71.4,20.3,16,40.5l2.3,6.3L73.6,26.7Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="#5c9833"
                d="M72.2,21.5,29.8,29a7.93,7.93,0,0,0-6.4,9.2l4,22.9a7.93,7.93,0,0,0,9.2,6.4L79,60a7.93,7.93,0,0,0,6.4-9.2L81.4,28A7.89,7.89,0,0,0,72.2,21.5Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="2px"
                d="M72.2,21.5,29.8,29a7.93,7.93,0,0,0-6.4,9.2l4,22.9a7.93,7.93,0,0,0,9.2,6.4L79,60a7.93,7.93,0,0,0,6.4-9.2L81.4,28A7.89,7.89,0,0,0,72.2,21.5Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="#fff"
                d="M81.7,29.4l-58,10.2,1.2,6.6L83,36Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="#fff"
                d="M80.4,32.4h-43a7.92,7.92,0,0,0-7.9,7.9V63.5a7.92,7.92,0,0,0,7.9,7.9H80.5a7.92,7.92,0,0,0,7.9-7.9V40.3A8,8,0,0,0,80.4,32.4Z"
                transform="translate(-0.39 -0.39)"
              />
            </g>
            <g id="Calque_6" data-name="Calque 6">
              <path
                fill="#fff"
                d="M80.4,32.4h-43a7.92,7.92,0,0,0-7.9,7.9V63.5a7.92,7.92,0,0,0,7.9,7.9H80.5a7.92,7.92,0,0,0,7.9-7.9V40.3A8,8,0,0,0,80.4,32.4Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="#5c9833"
                d="M66.9,32.7H37.3a7.92,7.92,0,0,0-7.9,7.9v23a7.92,7.92,0,0,0,7.9,7.9h4.5Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="2px"
                d="M80.4,32.4h-43a7.92,7.92,0,0,0-7.9,7.9V63.5a7.92,7.92,0,0,0,7.9,7.9H80.5a7.92,7.92,0,0,0,7.9-7.9V40.3A8,8,0,0,0,80.4,32.4Z"
                transform="translate(-0.39 -0.39)"
              />
            </g>
            <g id="Calque_3" data-name="Calque 3">
              <path
                fill="#5c9833"
                d="M57.6,57.1V53.9a1,1,0,0,1,.1-.3l7.9-11.1a.1.1,0,0,1,.1-.1H69V54.2h2.4v2.9H69v4.4H65.6V57.1ZM65.5,47l-4.8,7.1h4.8Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="#5c9833"
                d="M78.8,53.8c1.7,2.5,3.2,4.9,4.9,7.4H80l-3.1-4.9c-1.1,1.7-2.1,3.2-3.1,4.9H70.3l4.9-7.4c-1.5-2.3-3-4.4-4.5-6.8h3.6L77,51.5,79.9,47h3.5Z"
                transform="translate(-0.39 -0.39)"
              />
              <path
                fill="#fff"
                d="M41.2,42.3a3.81,3.81,0,0,1,1,.3,5.84,5.84,0,0,1,4,3,4.19,4.19,0,0,1-.8,5,3.69,3.69,0,0,1-1.4.7.37.37,0,0,0,.3.1,4.24,4.24,0,0,1,3,4.8C47,59,44.8,60.9,42,61.5a8.91,8.91,0,0,1-4.3-.2,6,6,0,0,1-4.4-5,.37.37,0,0,0-.1-.3V54.9h3.6a10.1,10.1,0,0,0,.3,1.7,3.44,3.44,0,0,0,1.3,1.6,2.82,2.82,0,0,0,2,.4A2.83,2.83,0,0,0,43.2,56a2.49,2.49,0,0,0-.9-2.4,3.51,3.51,0,0,0-1.8-.6,9.15,9.15,0,0,0-1.7-.1V50.3h.9a3.66,3.66,0,0,0,1.8-.4,2.28,2.28,0,0,0,.5-3.8,3,3,0,0,0-3-.5,2.49,2.49,0,0,0-1.7,2.1,3.75,3.75,0,0,0-.1,1.1H33.6c0-.5.1-.9.1-1.3a6.29,6.29,0,0,1,3.8-4.7c.5-.2,1-.2,1.5-.4Z"
                transform="translate(-0.39 -0.39)"
              />
            </g>
          </g>
        </g>
        <g id="Calque_3-2" data-name="Calque 3">
          <g id="Calque_3-3" data-name="Calque 3">
            <path
              fill="none"
              stroke="#fff"
              strokeWidth="1.22px"
              d="M5.9,1H98.4a4.91,4.91,0,0,1,4.9,4.9V81.4a4.91,4.91,0,0,1-4.9,4.9H5.9a5.06,5.06,0,0,1-4.9-5V5.9A4.91,4.91,0,0,1,5.9,1Z"
              transform="translate(-0.39 -0.39)"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default PaymentMethodREAIcon;
